import React, {useContext, useState} from 'react';
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Input from "@amzn/meridian/input";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Column from "@meridian/components/column";
import Text from "@amzn/meridian/text";
import Alert from "@amzn/meridian/alert"
import {CONFIG_TYPE, ZANCASORT_LOCATION_TYPES} from "../../../util/Constants";
import {DraftContext} from "../../../draftSave/context/DraftSaveContext";
import Select, {SelectOption} from "@amzn/meridian/select";
import {getLocalizedMessage} from "../../../util/Localization";

const AddZancaSortLocationConfigurationModal = (props) => {
    const {formatMessage} = props.intl;
    const {mac, intl} = props;
    const {getDraftData, addInstance, editInstance} = useContext(DraftContext)

    // Visual controls
    const {open, setOpen} = props
    const [show, setShow] = useState(false)
    const [edit, setEdit] = useState(false)

    // Values
    const [locationId, setLocationId] = useState("")
    const [locationType, setLocationType] = useState("")

    // Error
    const [locationIdErr, setLocationIdErr] = useState(false)
    const [locationTypeErr, setLocationTypeErr] = useState(false)

    const onCloseModal = () => {
        setShow(false);
        setOpen(false)
        resetInputState();
    }

    const modalLocationConfig = {
        locationId: locationId,
        locationType: locationType
    }

    /* Filling a map: locationConfigMap with locationId as key in case of an update of existing config */
    const locationConfigMap = {}
    getDraftData({stateKey: CONFIG_TYPE.ZANCA_SORT_LOCATION_CONFIGURATION, subKey: mac}).forEach(value => {
        locationConfigMap[value.locationId] = {
            locationType: value.locationType
        }
    });

    const checkValidations = () => {
        return locationId.trim() !== "" && locationType !== "";
    }

    const onClickConfirm = (modalLocationConfig, mac) => {
        if (checkValidations()) {
            setConfigData(modalLocationConfig, mac);
            setOpen(false)
            resetInputState();
            setShow(false);
        } else {
            setShow(true)
        }
    }

    function resetInputState() {
        setLocationId("");
        setLocationIdErr(false);
        setLocationType("");
        setLocationTypeErr(false);
        setEdit(false);
    }

    const prefill = () => {
        if (locationConfigMap.hasOwnProperty(locationId)) {
            setEdit(true);
            setLocationType(locationConfigMap[locationId].locationType);
            setLocationTypeErr(false);
        } else if (edit) {
            setEdit(false);
            setLocationType("");
        }
    }

    const setConfigData = (modalLocationConfig, mac) => {
        if(edit) {
            editInstance({
                stateKey: CONFIG_TYPE.ZANCA_SORT_LOCATION_CONFIGURATION,
                subKey: mac,
                instance: modalLocationConfig,
                keyComparator: (config1, config2) => (
                    config1.locationId === config2.locationId
                ),
                valueComparator: (config1, config2) => (
                    config1.locationType === config2.locationType
                )
            })
        } else {
            addInstance({
                stateKey: CONFIG_TYPE.ZANCA_SORT_LOCATION_CONFIGURATION,
                subKey: mac,
                instance: modalLocationConfig
            })
        }
    }

    return (
        <Row>
            <Modal
                title={formatMessage({id: "locationconfig.addupdate"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Column spacing={"medium"} spacingInset={"medium"}>
                    <Column spacing="200">
                        <b> <FormattedMessage id="modal.addlocationheading"
                                              defaultMessage="To edit an existing configuration, enter the Location Id."/>
                        </b>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="location-id-input">
                            {getLocalizedMessage({intl, stringId: "location.id"})}
                        </Text>
                        <Input id="location-id-input"
                               value={locationId}
                               onChange={setLocationId}
                               onBlur={() => {
                                   setLocationIdErr(locationId.trim() === "")
                                   prefill();
                               }}
                               error={locationIdErr}/>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="location-type-input">
                            {getLocalizedMessage({intl, stringId: "location.type"})}
                        </Text>
                        <Select id="location-type-input"
                            value={locationType}
                            onChange={setLocationType}
                            onBlur={() => {
                                setLocationTypeErr(locationType === "");
                            }}
                            placeholder={<FormattedMessage id="modal.enter_value"
                                               defaultMessage="Enter value..."/>}
                            width="100%"
                            error={locationTypeErr}>
                            {Object.values(ZANCASORT_LOCATION_TYPES).map(({label, value}, index) =>
                                <SelectOption key={index} value={value} label={label} />
                            )}
                        </Select>
                    </Column>
                </Column>
                <ModalFooter>
                    <Column>
                        {!checkValidations() &&
                            show &&
                            <Alert type="warning"
                                   size="small">
                                <FormattedMessage id="alert.missingfields"
                                                  defaultMessage="Please enter all fields in correct format!"/>
                            </Alert>}
                    </Column>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="medium" onClick={onCloseModal}>
                            <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                        </Button>
                        <Button type="primary" size="medium"
                                onClick={() => onClickConfirm(modalLocationConfig, mac)}>
                            { edit ? <FormattedMessage id="modal.confirmUpdate" defaultMessage="Confirm update"/>
                                : <FormattedMessage id="modal.confirmAdd" defaultMessage="Confirm add"/>}
                        </Button>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(AddZancaSortLocationConfigurationModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/zancasort/modal/AddZancaSortLocationConfigurationModal.js